import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { FiTrash2 } from "react-icons/fi";

const ConfirmDeleteModal = ({
  show,
  onClose,
  onConfirm,
  title = "Delete",
  message = "Are you sure you want to delete this item?",
  confirmText = "Yes, Delete",
  cancelText = "Cancel",
  loading = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="sm"
    >
      {/* HEADER */}
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">{title}</h5>
        <button className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      {/* BODY */}
      <Modal.Body className="text-center pt-2">
        <div className="delete-icon-wrapper mb-3">
          <FiTrash2 size={36} />
        </div>

        <p className="delete-message">{message}</p>
      </Modal.Body>

      {/* FOOTER */}
      <div className="modal-footer border-0 justify-content-center">
        <button
          className="btn btn-light px-4"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </button>

        <button
          className="btn btn-danger px-4"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? "Deleting..." : confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
